export class Helpers {

    public static getLocalStorage(name: string): string | null {
        return localStorage.getItem(name);
    }    

    public static setLocalStorage(name: string, value: string) {
        localStorage.setItem(name, value);
    }

    public static removeLocalStorage(name: string): void {
        localStorage.removeItem(name);
    }

    public static getSessionStorage(name: string): string | null {
        return sessionStorage.getItem(name);
    }

    public static setSessionStorage(name: string, value: string) {
        sessionStorage.setItem(name, value);
    }  

    public static getSessionStorageObject(name: string): any | null {
        try {
            var item: any = sessionStorage.getItem(name);

            if (item) {
                return JSON.parse(item);
            }
        }
        catch (err) {
            console.log(err);
        }

        return null;
    }

    public static setSessionStorageObject(name: string, obj: any) {
        try {
            let str = JSON.stringify(obj);
            sessionStorage.setItem(name, str);
        }
        catch (err) {
            console.log(err);
        }        
    }

    public static removeSessionStorage(name: string): void {
        sessionStorage.removeItem(name);
    }

    /**
     * Returns token expiration in milliseconds.
     */
    public static getExp(): number | null {
        return Number(sessionStorage.getItem("exp"));
    }

    public static setExp(exp: number) {
        sessionStorage.setItem("exp", exp.toString());
    }

    public static removeExp(): void {
        sessionStorage.removeItem("exp");
    }
}